import { Delete, Get, Post } from "domain/infra/data/api";
import CampanhaConstants from "../../infra/data/campanhaConstants";
import { LotePedidoResponse } from "../../types/lotePedido/lotePedidoResponse";
import { PagedListResponse } from "domain/types/global/pagedListResponse";
import { LotePedidoRequest } from "../../types/lotePedido/lotePedidoRequest";
import { DeletarPedidoRequest } from "../../types/lotePedido/deletarPedidoRequest";
import ValidationResult from "domain/types/global/validationResult";
import { PagedListRequest } from "domain/types/global/pagedListRequest";

export class LotePedidoService {
  constructor() { }

  async GetLotes(request: PagedListRequest<LotePedidoResponse>): Promise<PagedListResponse<LotePedidoResponse> | Error> {
    return await Post(
      CampanhaConstants.apiCampanha.CampanhaLotePedido.getLotes, request
    );
  }
  async GetLoteById(campanhaId: number): Promise<LotePedidoResponse | Error> {
    return await Get(
      `${CampanhaConstants.apiCampanha.CampanhaLotePedido.getLoteById}?id=${campanhaId}`
    );
  }
  async CreateLote(request: LotePedidoRequest): Promise<LotePedidoResponse | Error> {
    return await Post(CampanhaConstants.apiCampanha.CampanhaLotePedido.criarLote, request);
  }

  async Deletar(request: DeletarPedidoRequest, dispatchName: string): Promise<ValidationResult | Error> {
    return await Delete(`${CampanhaConstants.apiCampanha.CampanhaLotePedido.deletar}${request.LoteID}?usuario=${request.Usuario}&pagamentoStatusId=${request.PagamentoStatusID}`, dispatchName)
  }
}
